export const STATION_LIST_REQUEST = 'STATION_LIST_REQUEST';
export const STATION_LIST_SUCCESS = 'STATION_LIST_SUCCESS';
export const STATION_LIST_FAILURE = 'STATION_LIST_FAILURE';
export const STATION_RECORD_REQUEST = 'STATION_RECORD_REQUEST';
export const STATION_RECORD_SUCCESS = 'STATION_RECORD_SUCCESS';
export const STATION_RECORD_FAILURE = 'STATION_RECORD_FAILURE';
export const STATION_HISTORY_REQUEST = 'STATION_HISTORY_REQUEST';
export const STATION_HISTORY_SUCCESS = 'STATION_HISTORY_SUCCESS';
export const STATION_HISTORY_FAILURE = 'STATION_HISTORY_FAILURE';

export const stationListRequest = () => {
//    console.log('actions : ', STATION_LIST_REQUEST);

    return {
        type: STATION_LIST_REQUEST,
    }
}

export const stationListSuccess = (stationList) => {
//    console.log('actions : ', STATION_LIST_SUCCESS, stationList);
    return {
        type: STATION_LIST_SUCCESS,
        stationList,
    }
}

export const stationListFailure = (error) => {
//    console.log('actions : ', STATION_LIST_FAILURE);
    return {
        type: STATION_LIST_FAILURE,
        error,
    }
}

export const stationRecordRequest = (stationId) => {
//    console.log('actions : ', stationId, STATION_RECORD_REQUEST);

    return {
        type: STATION_RECORD_REQUEST,
        stationId,
        record: [],
    }
}

export const stationRecordSuccess = (stationId, record) => {
//    console.log('actions : ', STATION_RECORD_SUCCESS, record);
    return {
        type: STATION_RECORD_SUCCESS,
        stationId,
        record,
    }
}

export const stationRecordFailure = (stationId, error) => {
//    console.log('actions : ', STATION_RECORD_FAILURE);
    return {
        type: STATION_RECORD_FAILURE,
        stationId,
        error,
    }
}

export const stationHistoryRequest = (stationId, params) => {
//    console.log('actions : ', stationId, STATION_HISTORY_REQUEST);

    return {
        type: STATION_HISTORY_REQUEST,
        stationId,
        params,
        history: [],
    }
}

export const stationHistorySuccess = (history) => {
//    console.log('actions : ', STATION_HISTORY_SUCCESS, history);
    return {
        type: STATION_HISTORY_SUCCESS,
        data: history,
    }
}

export const stationHistoryFailure = (error) => {
//    console.log('actions : ', STATION_HISTORY_FAILURE);
    return {
        type: STATION_HISTORY_FAILURE,
        error,
    }
}